// ─────────────────────────────────────────────────────────────────
// SDI GlassBox — Demo Session Configuration
// Safe to commit. No secrets. All sensitive values live in Wix Secrets.
// ─────────────────────────────────────────────────────────────────

// Shell endpoint — Wix backend
// In local dev, the Vite proxy forwards /_functions/* to sdi-protocol.org
// In production (demo.sdi-protocol.org), requests go directly to Wix
export const SHELL_ENDPOINT =
  import.meta.env.VITE_SHELL_ENDPOINT ??
  "https://api.sdi-protocol.org/shell/turn";

// Demo agent — shared across all NIST demo sessions
export const DEMO_AGENT_ID = "SDI-4EDBE05288CB";

// Protocol constants
export const CONTRACT_VERSION = "SDI_DER_v1.1";
export const CONTRACT_SOURCE  = "sdi-protocol.org/_functions/manifest";
export const POLICY_MODE      = "DEMO";
export const TURN_LIMIT       = 3;

// Display-only sovereign hash — truncated for UI
// Real value lives in Wix Secrets as SDI_DEMO_SOVEREIGN_HASH
export const DISPLAY_SOVEREIGN_HASH = "0x4C7C3E55AC86476A025460F8...";

// Session object passed to GlassBox as the `session` prop
// Values here are display/boot values — runtime values come from turn results
export const DEMO_SESSION = {
  agent_id:         DEMO_AGENT_ID,
  sovereign_hash:   DISPLAY_SOVEREIGN_HASH,
  contract_version: CONTRACT_VERSION,
  contract_source:  CONTRACT_SOURCE,
  policy_mode:      POLICY_MODE,
  model_provider:   "anthropic/claude-sonnet-4-6",
  tip_seq:          3,    // updated in GlassBox state after each COMMIT
  chain_ok:         true, // updated from chain_verify in turn result
};
